import Cookies from 'js-cookie';

VIV.behaviours.docsidebar = (function () {

    const attach = function (context) {
        const baseClass = 'docsidebar';
        const sidebar = context.querySelector(`.${baseClass}`);
        const sidebarContent = context.querySelector(`.${baseClass}__content`);
        const toggle = document.querySelector('.docsSidebarTrigger');
        const search = context.querySelector(`.${baseClass}__search`);
        const links = context.querySelectorAll(`.${baseClass}__link:not(.${baseClass}__link--docs)`);

        if (!sidebar) {
            return;
        }

        document.querySelectorAll('.docsidebar__link--docs').forEach(link => {
           link.addEventListener('click', () => {
               const id = link.getAttribute('data-id');
               const target = document.querySelector(`#${id}`);
               const showDocsLink = target && target.closest('.docblock').querySelector('.docblock__showDocs');
               console.log(showDocsLink);
               if (showDocsLink && !showDocsLink.classList.contains('docblock__showDocs--active')) {
                   showDocsLink.click();
               }
           })
        });

        // Toggle sidebar visibility
        toggle.addEventListener('click', () => {
            if (document.documentElement.classList.toggle(`sidebarOpen`)) {
                Cookies.set('sidebarOpen', 'true');
            } else {
                Cookies.set('sidebarOpen', 'false');
            }
        });

        // Restore sidebar state from cookie
        if (Cookies.get('sidebarOpen') === 'true') {
            document.documentElement.classList.add('sidebarOpen');
        }

        const navItems = context.querySelectorAll('.docblock');

        var lastScrollTop = 0;

        const handleSearch = function (e) {
            const value = e.target.value.toLowerCase().replace({' ': ''});
            if (value.length === 0) {
                links.forEach(link => link.parentElement.removeAttribute('hidden'));
            }
            links.forEach(link => {
                const text = link.innerText.toLowerCase().replace({' ': ''});
                if (text.indexOf(value) === -1) {
                    link.parentElement.setAttribute('hidden', 'hidden');
                } else {
                    link.parentElement.removeAttribute('hidden');
                }
            });
        };

        search.addEventListener('keyup', handleSearch);
        search.addEventListener('change', handleSearch);
        document.addEventListener('keydown', function(event) {
            if (event.metaKey && event.key === 'f') {
                if (document.activeElement !== search) {
                    event.preventDefault();
                    search.focus();
                    search.select();
                }
            }
        });

        const isElementInViewport = function (el) {
            const rect = el.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        }


        // Import lodash async
        import(/* webpackChunkName: "lodash" */ "lodash").then(module => {
            const _ = module.default;

            const getFirstItem = function (navItems, _) {
                let first = null;
                _.forEach(navItems, element => {
                    const rect = element.getBoundingClientRect();
                    if ((rect.top + window.scrollY) > (window.scrollY - element.offsetHeight + 50)) {
                        first = element;
                        return false;
                    }
                });
                return first;
            }

            window.addEventListener('scroll', _.throttle(() => {
                const firstItem = getFirstItem(navItems, _);
                let dir = 'up';
                if (firstItem) {
                    const active = sidebarContent.querySelector(`.${baseClass}__item--active`);
                    if (active) {
                        active.classList.remove(`${baseClass}__item--active`);
                    }

                    const st = document.documentElement.scrollTop;
                    const item = firstItem.querySelector('.docblock__anchor')
                    const id = item && item.getAttribute('id');
                    const activeElement = sidebarContent.querySelector('a[href="#' + id + '"]');
                    if (activeElement) {
                        activeElement.parentElement.classList.add(`${baseClass}__item--active`);
                    }
                    lastScrollTop = st <= 0 ? 0 : st;
                }
            }, 100));
        });
    }

    return {
        attach: attach
    }
})();
